export enum CopyFormStage {
  BasicData = 0,
  SheetDefinition = 1,
}
